import React, { useEffect } from 'react';
import { Router } from "@reach/router";
import Layout from '../components/Layout';
import SignUp from '../sections/SignUp';
import { STORAGE_KEYS } from '../resources/constants';
import { trackStatsService } from '../services/services';

const IndexPage = () => {

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEYS.ADID))
      trackStats();
  }, []);

  const trackStats = async() => {
    const data = {
      event: 'VISIT'
    };
    try{
      let response = await trackStatsService(data);
      if (response.status == "200"){
        getData();
      }
    }catch(error){
        console.log(error);
    };
  };

  const getData = async() => {
    let adid = '';
    let adgroup = '';
    const queryString = window.location.search.substr(1).split('&');
    if (queryString[0] != '') {
      adid = queryString[0].split('=')[1];
      adgroup = queryString[1].split('=')[1];
    }
    localStorage.setItem(STORAGE_KEYS.ADID, adid);
    localStorage.setItem(STORAGE_KEYS.ADGROUP, adgroup);
  };

  return (
    <Layout header={true}>
      <Router basepath="/">
        <SignUp path="/" />
      </Router>
    </Layout>
  );
};

export default IndexPage;
